import React, { Component } from 'react';
import Key from '../Key';
import {testKeyFromArr} from '../Key';

var keys = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0'
]

var Keyboard = React.createClass({
  componentWillReceiveProps(nextProps) {
    if(JSON.stringify(nextProps.opperativeKey) !== JSON.stringify(this.props.opperativeKey)) {
      if(nextProps.opperativeKey.keyCode == '8'){
        this.handleErase();
        return;
      }
      if(typeof nextProps.opperativeKey.key != 'undefined'){
        if(testKeyFromArr(nextProps.opperativeKey.key, keys)){
          this.handleClickButton(nextProps.opperativeKey.key)
        }
      }
      
    }
  },
  handleClickButton: function(data){
    var inputText = this.props.text,
        result = '',
        workStr = '',
        endStr = ' 000 р.';

    workStr = inputText.replace( / 000 \р\./g, '');
    if(workStr.length < 3){
      if(/\*/.test(workStr)){
        result = workStr.replace( /\*/, data) + endStr;
      }else{
        result = workStr + data + endStr;
      }
    }

    if(/\d\d\d 000 \р\./.test(result)){
      this.props.actionDoneNext(result);
      return;
    }

    if(!result){
      return;
    }

    this.props.actionSaveField(result)
  },
  handleErase: function(data){
    var inputText = this.props.text,
        result = '',
        workStr = '',
        endStr = ' 000 р.';

    workStr = inputText.replace( / 000 \р\./g, '');

    if(/\d\d\d/.test(workStr)){
      result = workStr.replace( /.$/g, '');
      result += endStr
    }else if(/\d\d/.test(workStr)){
      result = workStr.replace( /.$/, '*') + endStr;
    }else{
      result = workStr.replace( /\d/, '*') + endStr;
    }

    this.props.actionSaveField(result)
  },
  render: function(){
    if (!this.props.mobile) {
      return(
        <div className="keyboardWrapper">
          <div className="leftVoid">
            <div className="voidBlock"></div>
          </div>
          <div className="Keyboard numbers">
            <Key actionClickButton={this.handleClickButton} val="1" />
            <Key actionClickButton={this.handleClickButton} val="2" />
            <Key actionClickButton={this.handleClickButton} val="3" />
            <Key actionClickButton={this.handleClickButton} val="4" />
            <Key actionClickButton={this.handleClickButton} val="5" />
            <Key actionClickButton={this.handleClickButton} val="6" />
            <Key actionClickButton={this.handleClickButton} val="7" />
            <Key actionClickButton={this.handleClickButton} val="8" />
            <Key actionClickButton={this.handleClickButton} val="9" />
            <div className="button empty"></div>
            <Key actionClickButton={this.handleClickButton} val="0" />
            <div className="button empty"></div>
          </div>
          <div className="rightVoid">
            
          </div>
        </div>
      );
    }else{
      // return(
      //   <div className="keyboardWrapper Numbers">
      //     <div className="Keyboard numbers">
      //       <div className="row">
      //         <div className="innerTable">
      //           <div className="row">
      //             <Key actionClickButton={this.handleClickButton} val="1" />
      //             <Key actionClickButton={this.handleClickButton} val="2" />
      //             <Key actionClickButton={this.handleClickButton} val="3" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClickButton} val="4" />
      //             <Key actionClickButton={this.handleClickButton} val="5" />
      //             <Key actionClickButton={this.handleClickButton} val="6" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClickButton} val="7" />
      //             <Key actionClickButton={this.handleClickButton} val="8" />
      //             <Key actionClickButton={this.handleClickButton} val="9" />
      //           </div>
      //         </div>
      //       </div>
      //       <div className="row" style={{height: "25%"}}>
      //         <div className="innerTable">
      //           <Key className="serviceClass serviceClass2" actionClickButton={this.handleClickButton} val="0" style={{width: "33.5%"}}/>
      //           <div className="serviceClass button" onClick={this.handleErase}>Стереть</div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // );
      return null
    }
  }
});

export default Keyboard;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/components/NumbersMoney/index.jsx
 **/